import React from 'react';

export type LegendItem = {
  key: string;
  label: string;
  color: string;
  value?: string;
  /** A filled square (default) or a dotted line. */
  swatch?: 'square' | 'dotted';
};

interface ChartLegendProps {
  items: LegendItem[];
  direction?: 'row' | 'column';
}

const ChartLegend = ({ items, direction = 'row' }: ChartLegendProps) => (
  <ul
    className={`flex text-sm text-textGray ${
      direction === 'row' ? 'flex-row flex-wrap gap-x-5 gap-y-2' : 'flex-col gap-2'
    }`}
  >
    {items.map((item) => (
      <li key={item.key} className="flex items-center gap-2 min-w-0">
        {item.swatch === 'dotted' ? (
          <span
            className="inline-block w-0 h-3 border-l-2 border-dotted mx-[5px] flex-shrink-0"
            style={{ borderColor: item.color }}
          />
        ) : (
          <span
            className="inline-block w-3 h-3 rounded-sm flex-shrink-0"
            style={{ backgroundColor: item.color }}
          />
        )}
        <span className="truncate">{item.label}</span>
        {item.value && (
          <span className="ml-auto pl-3 text-mainWhite tabular-nums whitespace-nowrap">
            {item.value}
          </span>
        )}
      </li>
    ))}
  </ul>
);

export default ChartLegend;
